import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/application/ThemeRegistry.tsx");
